
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = $('body').data('money-format');
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function changeComparePrice(time){
  $('.product__info-container .price__loader').css('display','flex');
  $('.product__info-container .price__regular').hide();
  setTimeout(function() {

    var count=0;
    var x=setInterval(function(){

    var price = $('.product__info-container .price__regular .price-item--regular').data('price');

    $('.gpo-element .gpo-swatches input[type="radio"]:checked').each(function(i, obj) {
      var price_addon = $(this).closest('.gpo-element').find('.gpo-label span.addOn').text();
      price_addon = price_addon.replace(" ", "").replace("(", "").replace(")", "").replace("+$","").replace("+£","").replace("+€","").replace(",",".");
     // console.log(price_addon);
      price_addon = price_addon * 100;
     // console.log(price_addon);
      price = parseInt(price) + price_addon;
    });

    $('.spice-spa-addon-product-item').each(function(i, obj) {
      var checkbox = $(this).find('.spice-spa-addon-checkbox-input:checked');
      if (checkbox.length > 0){
         var variant_price =  $(this).find('.spice-spa-addon-price-main').attr('variant_price');
         var variant_quantity =  $(this).find('[name="sg-pro-access-qty"]').val();
        variant_price = parseInt(variant_price) * variant_quantity;
        console.log(variant_price);
        price = parseInt(price) + variant_price;
      }
    });

    var percent_price = $('.product__info-container .price__regular .price-item--regular').data('percent');
    var check_fake_price = $('.product__info-container .price__regular .price-item--regular').data('fake');
    var calculator_price = (100 - percent_price) * 0.01;

    if(check_fake_price == true){
      var sale_price = price; 
      var original_price = price / calculator_price;
    }else{
      var sale_price = price * calculator_price; 
      var original_price = price;
    }
  

    $('.product__info-container .price__regular .price-item--regular,.price_mb .mainPrice').text(Shopify.formatMoney(sale_price, $('body').data('money-format')));
    $('.product__info-container .price__regular .price-item--sale,.price_mb .savePrice').text(Shopify.formatMoney(original_price, $('body').data('money-format')));
   
      
      if(count > 5){
      //  console.log('stop Interval');
        clearInterval(x);
        $('.product__info-container .price__loader').hide();
        $('.product__info-container .price__regular').css('display','flex');
      }
      count++;
    }, time);
    
  }, 1000);
}

function changeBackground(){
  setTimeout(function() {
    var pictureType = $('input[name="Select Picture Style"]:checked').val();
    if(pictureType == undefined){
      pictureType = $('input[name="Select Picture Style"]').first().val();
    }
    var premadeBackground = $('input[name="Select Background"]:checked').val();
    if(premadeBackground == undefined){
      premadeBackground = $('input[name="Select Background"]').first().val();
    }
    
    var combined = pictureType +' - '+ premadeBackground;
    combined = combined.toLowerCase().replace("'", "").replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    if(combined != ''){ 
      var sectionID = $('#product-section-id').val();                           
      var imageID = $('.img-'+combined).data('image-id');
      const mediaGallery = document.getElementById('MediaGallery-'+sectionID);
      mediaGallery.setActiveMedia(sectionID+'-'+imageID, true);
      const modalContent = document.querySelector('#ProductModal-'+sectionID+' .product-media-modal__content');
      const newMediaModal = modalContent.querySelector('[data-media-id="'+imageID+'"]');
      modalContent.prepend(newMediaModal);
    }
    
  }, 300);
}

function changeAddonAdditionalInfo(){

  $('.spice-spa-addon-product-item').each(function(i, obj) {
    var checkbox = $(this).find('.spice-spa-addon-checkbox-input:checked');
    if (checkbox.length > 0){
   
      var AdditionalField =  $(this).find('.spice-spa-addon-product-text-field');
      if (AdditionalField.length > 0){
      
        var pid= $(this).find('.spice_properties');               
        var headingName = $('.product__info-container .product__title').text();
        var numberValue = $('input[name="Select Number of People and Pets"]:checked').val();
        var styleValue = $('input[name="Select Picture Style"]:checked').val();
        var backgroundValue = $('input[name="Select Background"]:checked').val();

        var stringInfo = $.trim(headingName);
             
        if(numberValue != ''){
          stringInfo += ' - ' + numberValue;
        }
        if(styleValue != ''){
          stringInfo += ' - ' + styleValue;
        }
        if(backgroundValue != ''){
          stringInfo += ' - ' + backgroundValue;
        }
        pid.text(stringInfo);
      }
    }
  });
  
}

function checkRequiredFields(){
  var check_error = false;
  $('.gpo-form__group.show-addon-for-option').each(function(i, obj) {
    if($(this).hasClass("has-error")){
      check_error = true;
    }
  });  
  if(!check_error){
    $('button.product-form__submit').attr('disabled',false);
  }else{
    $('button.product-form__submit').attr('disabled',true);
    $('input.spice-spa-addon-checkbox-input').each(function(i, obj) {
      $(this).prop("checked",false);
    });
  }
}


// Get the new parent element - button ATC
const buttonATCParent = document.getElementById('product-form__buttons');

// Get the element to move - price
const priceToMove = document.querySelector('.price-section'); 

// Move the element
if(buttonATCParent){
  buttonATCParent.prepend(priceToMove); 
}

$( window ).on( "load", function() {

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const paramCart = urlParams.get('cart');
  if(paramCart){
     $("#shopping-bag").addClass('show-bag');
  }

  // Fix confict Discount Ninja app
  /*
  $.getJSON("/cart.js", function (results) {
console.log('Fix confict Discount Ninja app');
    var checkThrowBlanketFree = false;
    results.items.forEach(item => {
      console.log(item);
      if(item.product_title == 'Throw Blanket'){
        checkThrowBlanketFree = true;
      }
    });
    console.log(checkThrowBlanketFree);
    if(checkThrowBlanketFree){
      $('#shopping-bag .sb-product').each(function(index, element) {
        var checkThrowBlanket = $(this).data("title"); 
        if(checkThrowBlanket == 'Throw Blanket'){
          $(this).find('.sb-price').text(Shopify.formatMoney(0, $('body').data('money-format')));
        }
      });
      $("#shopping-bag").addClass('show-bag');    
    }
  });
  */

  $('.start-now-inner a').click(function(event) {
    $('button#ProductPopup-more-info').click();
  });  

  $('#ModalClose-video-example').click(function(event) {
     $("#shopping-bag").addClass('show-bag');
  });  

  $('.main-product-form .product-form__submit').click(function(event) {
    event.preventDefault();
      var thisButtonATC = $(this);
      var itemsToAdd = [];
      var $form = $(this).closest('form.main-product-form');
      var parentVariantId = $form.find('input[name="id"]').val();
      var parentProductTitle = $form.find('#product_title').val();
      console.log(parentVariantId); 
      var selectBackground = $('input[name="Select Background"]:checked').val();

      var propertiesToAdd = {};
      $('.main-product-form .gpo-hidden-inputs input[data-field-name]').each(function(index, element) {
          var keyProperties = $(this).data('field-name');
          var valueProperties = $(this).val();
          if(valueProperties != ''){
            propertiesToAdd[keyProperties] = valueProperties;
          }
      });  

      propertiesToAdd['product_group'] = parentVariantId+'-'+selectBackground;

      console.log(propertiesToAdd);
     
      if(parentVariantId != ''){
        itemsToAdd.push({
            id: parentVariantId, 
            quantity:  1,
            properties: propertiesToAdd
        });
      }

      $('.main-product-form .gpo-hidden-inputs input[gpo-data-variant-id]').each(function(index, element) {
        var childVariantId =  $(this).attr('gpo-data-variant-id');
        console.log(childVariantId);
        if(childVariantId != ''){
          var propertiesToAdd = {};
          //propertiesToAdd["Additional Info"] = parentProductTitle;
          propertiesToAdd["parent_product_group"] = parentVariantId+'-'+selectBackground;
          itemsToAdd.push({
              id: childVariantId, 
              parent_id: parentVariantId,
              quantity: 1,
              properties: propertiesToAdd
          });
        }
      });

      $('.main-product-form input[name="spice_productid"]').each(function(index, element) {
        if ($(this).prop('checked')) {
          var addonVariantId = $(this).closest('.spice-spa-addon-product-item').find('.spice-spa-addon-form [name="spice_select_variant_id"]').val();
          var addonVariantQty = $(this).closest('.spice-spa-addon-product-item').find('.spice-spa-addon-form [name="sg-pro-access-qty"]').val();
          console.log("Checkbox is checked: "+addonVariantId);
          if(addonVariantId != ''){
            var propertiesToAdd = {};
            //propertiesToAdd["Additional Info"] = parentProductTitle;
            propertiesToAdd["parent_product_group"] = parentVariantId+'-'+selectBackground;
            itemsToAdd.push({
                id: addonVariantId, 
                parent_id: parentVariantId,
                quantity: addonVariantQty,
                properties: propertiesToAdd
            });
          }
        }
      });

      console.log(itemsToAdd);

      thisButtonATC.addClass('loading').attr('aria-disabled', true);
      thisButtonATC.find('.loading-overlay__spinner').removeClass('hidden');
      
      let formData = {
      'items': itemsToAdd
      };

      console.log(formData);



      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        //return response.json();
          cart_load();
          thisButtonATC.removeClass('loading').removeAttr('aria-disabled');
          thisButtonATC.find('.loading-overlay__spinner').addClass('hidden');
          setTimeout(function() {
           $("#shopping-bag").addClass('show-bag');
          }, 300); 
      })
      .catch((error) => {
        console.error('Error:', error);
      });
     
  });

   // Correct wrong text  
  $('.gpo-container .gpo-element .label-content').each(function(i, obj) {
    var valueLabel = $(this).text();
    $(this).text(valueLabel.toLowerCase());
  });
  
  $('input[name="Select Number of People and Pets"]').prop('checked',false);
  $('input[name="Select Picture Style"]').prop('checked',false);
  $('.spice-spa-addon-heading').text('Get Your Artwork Printed');

  $('.prev-step').click(function(){
    var currentStep = $(this).attr('data-step');
    // Go to next step
    var prevStep = parseInt(currentStep) - 1;
    $(this).attr('data-step',prevStep);
    $('.next-step').attr('data-step',prevStep);
    $('.wrapp_steps_top').attr("id","step-"+prevStep);
    // Display content for next step
    if(prevStep == 1){
      $('.show-addon-for-option').show();
      $('.variant-radios,.uploadkit,.uploadlift,.show-addon-for-input,.prev-step').hide();

      $('.step-item.step-item-1').removeClass('completed').addClass('active');
      $('.step-item.step-item-2').removeClass('active');
      $('.step-progress-bar').attr('aria-valuenow',0).find('.step-progress-bar-active').css('width','10%');
      $('.step_title').text('Select Background?');

      var premadeBackground = $('input[name="Select Background"]:checked').val();
      console.log(premadeBackground);
      if(premadeBackground != undefined){
       //$('.next-step').removeClass('disabled');
      }
      
    }else if(prevStep == 2){
      $('.variant-radios,.uploadkit,.uploadlift,.show-addon-for-input,.next-step').show();
      $('.next-step').addClass('active');
      $('#spiceaddonsappid,.product-form__submit').hide();

      $('.step-item.step-item-2').removeClass('completed').addClass('active');
      $('.step-item.step-item-3').removeClass('active');
      $('.step-progress-bar').attr('aria-valuenow',50).find('.step-progress-bar-active').css('width','50%');
       $('.step_title').text('Select Portrait Details');
    }
    $('html, body').animate({
        scrollTop: $("#product__info-wrapper").offset().top
    }, 'smooth');
  });

  $('.next-step').click(function(){
    var currentStep = $(this).attr('data-step');
    if(currentStep == 1){
      var premadeBackground = $('input[name="Select Background"]:checked').val();
      console.log(premadeBackground);
      if(premadeBackground == undefined){
        $(".select-background-option").shake();
        return;
      }
    }
    if(currentStep == 2){
      var number = $('input[name="Select Number of People and Pets"]:checked').val();
      console.log(number);
      if(number == undefined){
        var $scrollableDiv = $('#product-form-wrapper'); // The fixed, scrollable div
        $scrollableDiv.animate({
            scrollTop: 0
        }, 200);
        $(".select-number-of-people-and-pets").shake();
        return;
      }
      var style = $('input[name="Select Picture Style"]:checked').val();
      console.log(style);
      if(style == undefined){
        var $scrollableDiv = $('#product-form-wrapper'); // The fixed, scrollable div
        $scrollableDiv.animate({
            scrollTop: 100
        }, 200);
        $(".select-picture-style").shake();
        return;
      }
    }

    // Go to next step
    var nextStep = parseInt(currentStep) + 1;
    $('.prev-step').attr('data-step',nextStep);
    $(this).attr('data-step',nextStep);
    $('.wrapp_steps_top').attr("id","step-"+nextStep);
    // Display content for next step
    if(nextStep == 2){
      $('.show-addon-for-option').hide();
      $('.variant-radios,.uploadkit,.uploadlift,.show-addon-for-input,.prev-step').show();
      $('.step-item.step-item-1').addClass('completed');
      $('.step-item.step-item-2').addClass('active');
      $('.step-progress-bar').attr('aria-valuenow',50).find('.step-progress-bar-active').css('width','50%');
      $('.step_title').text('Select Portrait Details');
      var number = $('input[name="Select Number of People and Pets"]:checked').val();
      var style = $('input[name="Select Picture Style"]:checked').val();
      if(number == undefined || style == undefined){
        //$('.next-step').addClass('disabled');
      }
    }else if(nextStep == 3){
      $('.variant-radios,.uploadkit,.uploadlift,.show-addon-for-input,.next-step').hide();
      $('.next-step').removeClass('active');
      $('#spiceaddonsappid,.product-form__submit').show();
      $('.step-item.step-item-2').addClass('completed');
      $('.step-item.step-item-3').addClass('active');

      $('.step-item.step-item-2').addClass('completed');
      $('.step-item.step-item-3').addClass('active');
      $('.step-progress-bar').attr('aria-valuenow',100).find('.step-progress-bar-active').css('width','100%');
      $('.step_title').text('Add-ons');

      //$('.main-product-form .spice-spa-addon-product-btn').first().click();
    }
    $('html, body').animate({
        scrollTop: $("#product__info-wrapper").offset().top
    }, 'smooth');
  });


  $('.close-custom-mob').click(function(){
    $('body').removeClass('active-sticky-bottom');
    $('#product-form-wrapper').removeClass('active');
    $('.prd_mobile_button_sticky').show();
  });

  $('.close-wrap-qty').click(function(){
    $('label.toggle-quantity-label').click();
  });

  
  // Border text for AU Father’s Day
  $('.product__info-container p.product__text').each(function(i, obj) {
    console.log($(this).text());
    
    if($(this).text().indexOf('AU Father’s Day Special') != -1){
        $(this).addClass('border');
    }
  });

  // custom dropdown Number of People and Pets
  setTimeout(function() {

    $('#custom-dropdown-gift').change(function(){
      console.log($(this).val());
      const giftVal = $(this).val();
      $('input[name="Denominations"][value="'+giftVal+'"]').prop('checked', true);
    });

    
    // Get the element to move - price
    const drawingNotesToMove = document.querySelector('.gpo-element.show-addon-for-input'); 
    // Move the element
    const drawingNotes = document.querySelector('.drawing-notes');
    if(drawingNotes){
      drawingNotes.after(drawingNotesToMove); 
    }
    
  }, 500);  

  $('.gpo-element .gpo-swatches input[type="radio"]').click(function(){
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 500);
  });
  
  $('input[name="Select Background"]').click(function(){
    
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    checkRequiredFields();
     var selectedValue = $('input[name="Select Background"]:checked').val();
     if(selectedValue == undefined){
      //$('.next-step').addClass('disabled');
     }else{
      //$('.next-step').removeClass('disabled');
      var number = $('input[name="Select Number of People and Pets"]:checked').val();
      if(number == undefined){
        number = $('input[name="Select Number of People and Pets"]').first().val();
      }
      var style = $('input[name="Select Picture Style"]:checked').val();
      if(style == undefined){
        style = $('input[name="Select Picture Style"]').first().val();
      }
      changeBackground();
     }
  });
  
  $('input[name="Select Picture Style"]').click(function(){
    
    
    setTimeout(function() {
      checkRequiredFields();
    }, 1000);
    var number = $('input[name="Select Number of People and Pets"]:checked').val();
    var style = $('input[name="Select Picture Style"]:checked').val();
    if(number != undefined && style != undefined){
      //$('.next-step').removeClass('disabled');
     changeBackground();
     changeComparePrice(200);
     changeAddonAdditionalInfo();
    }
  });
  
  $('input[name="Select Number of People and Pets"]').click(function(){
   
    setTimeout(function() {
      checkRequiredFields();
    }, 1000);
    var quantity = $(this).val();
    $('.quantity-wrapp .quantity-number').val(quantity);
    if(quantity < 7){
      $('.product-form__input.select-number-of-people-and-pets label.toggle-quantity-label').addClass('active');
      $('.quantity-wrapp').hide();
      $('.toggle-quantity-label').removeClass("active").removeClass('current').text("+");
    }
    var number = $('input[name="Select Number of People and Pets"]:checked').val();
    var style = $('input[name="Select Picture Style"]:checked').val();
    if(number != undefined && style != undefined){
      //$('.next-step').removeClass('disabled');
      changeBackground();
       changeComparePrice(200);
       changeAddonAdditionalInfo();
    }
  });

  const toggleQuantity = `<label class="toggle-quantity-label">+</label>`;
  $('.product-form__input.select-number-of-people-and-pets input[name="Select Number of People and Pets"][value="7"]').before(toggleQuantity);
  $('.product-form__input.select-number-of-people-and-pets label.toggle-quantity-label').click(function(){
    $('.quantity-wrapp').toggle();
    $('.toggle-quantity-label').toggleClass("active");
    $('.product-form__input.select-number-of-people-and-pets').toggleClass("other_qty");
    var currentQuantity = $('input[name="Select Number of People and Pets"]:checked').val();
    console.log(currentQuantity);
    if(currentQuantity < 7){
      currentQuantity = 7;
      $('.toggle-quantity-label').removeClass('current');
      $('.toggle-quantity-label').text("+");
    }else{
      $('.toggle-quantity-label').addClass('current');
      $('.toggle-quantity-label').text(currentQuantity);
    }
    $('.quantity-wrapp .quantity-number').val(currentQuantity);
    $('.product-form__input.select-number-of-people-and-pets input[name="Select Number of People and Pets"][value="'+currentQuantity+'"]').next().trigger("click");
  });

  for (let i = 7; i < 15; i++) {
    console.log(i);
    $('.product-form__input.select-number-of-people-and-pets label.'+i).hide().addClass('hide');
  } 

  setTimeout(function() {

    if($('.gpo-element .gpo-swatches input[type="radio"]').length > 0){
      changeComparePrice();
    }

    $('.gpo-element.show-addon-for-option.select-background-option .gpo-ov-wrapper').after('<div class="gpo-ov-wrapper custom-bg"></div>');

    $('.gpo-ov-wrapper.custom-bg').append($('.gpo-element.show-addon-for-option.select-background-option .gpo-ov-wrapper .image-swatches.gpo-ov-item').last());
    $('.gpo-ov-wrapper.custom-bg .gpo-swatch__inner .swatch-image').attr('src','https://cdn.shopify.com/s/files/1/0568/3275/3819/files/1091cf386c71f7f5b195874263987c9fb20b0e73.png?v=1762768209');    
    
    $('.gpo-swatches.image-swatches .gpo-tooltip').each(function(i, obj) {
      var title = $(this).find('span:first-child').text();
      var proOptionTitle = $('.product__info-wrapper .holiday_text').data('option-title');
      var holidayText = $('.product__info-wrapper .holiday_text').text();

       // Convert the string to an array and trim white spaces
      var arrayOption = proOptionTitle.split(',').map(function(item) {
          return item.trim();
      });

      if ($.inArray(title, arrayOption) !== -1) {
        console.log(title + " is found in the array.");
        title = title.replace('Fathers Day','Fathers Day<br>');
        title += '<span>'+holidayText+'</span>';
      }
        /*
      if(title.indexOf(proOptionTitle) != -1){
        title += '<span>('+holidayText+')</span>';
      }
    
      if(title.indexOf('Fathers Day') != -1){
        title += '<span>(LIMITED TIME ONLY)</span>';
      }
      */
      var price = $(this).find('span.addOn').text();
      price = price.replace(" ", "").replace("(", "").replace(")", "");
      if(price == ''){
       price = '+' + Shopify.formatMoney(0, $('body').data('money-format')); 
      }
      var compare_price = 0;
      var variant_id = $(this).parent().prev().attr('gpo-data-variant-id');
      /*
      for (var i = 0; i < addonItems.length; i++) {
        if(variant_id == addonItems[i][0]['id']){
          compare_price = addonItems[i][0]['compare_at_price'];
          if(compare_price == null){
            var itemPrice = addonItems[i][0]['price'];
            var percent_price = $('.product__info-container .price__regular .price-item--regular').data('percent');
            var calculator_price = (100 - percent_price) * 0.01;
            compare_price = itemPrice / calculator_price; 
          }
        }
      }
        */
      //compare_price = compare_price / 100;
      console.log(compare_price);

       var enable_compare_price = $('form.main-product-form').data('enable-compare-price');
      console.log(enable_compare_price);

       var custom_bg_class = '';
       if(title.indexOf('Make Your Own') != -1 || title.indexOf('Custom') != -1){
          title = 'Make It Yours with Custom Backgrounds';
          var customBackgroundTitle = '';
          if(customBackgroundTitle != ''){
            title = customBackgroundTitle;
          }
          $(this).find('.gpo-tooltip__title').html(title);
          var custom_bg_class = 'gpo-price-badge';
      }
      
      if(compare_price > 0 && enable_compare_price){
        $(this).parent().append("<div class='gpo-product-option-title'>"+title.toLowerCase()+ "</div>" + "<div class='gpo-product-price "+custom_bg_class+"'>"+price+" <del>"+Shopify.formatMoney(compare_price, $('body').data('money-format'))+"</del>"+"</div>");
      }else{
        $(this).parent().append("<div class='gpo-product-option-title'>"+title.toLowerCase()+ "</div>" + "<div class='gpo-product-price "+custom_bg_class+"'>"+price+"</div>");
      }
    });
    
  }, 300);
  
  /* Sticky Preview
  var windowWidth = $(window).width();
  if (windowWidth <= 750 && $('.product-form__submit').length > 0) {
    $(window).scroll(function() {

      if ($(this).scrollTop() > 106 ) {
        //$('.product__media-wrapper').addClass("sticky");
        //$('.product__info-wrapper').addClass("sticky");
        $('.product__media-wrapper').addClass("preview");
        $('.product__info-wrapper').addClass("preview");
      }else{
        //$('.product__media-wrapper').removeClass("sticky");
        //$('.product__info-wrapper').removeClass("sticky");
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

      if ($(this).scrollTop() > $('.product-form__submit').offset().top ) {
        //$('.product__media-wrapper').removeClass("sticky");
        //$('.product__info-wrapper').removeClass("sticky");
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

    });
  }
  */

});

/*
$(window).on('resize', function() {
  var windowWidthResize = $(window).width();
  if (windowWidthResize <= 750 && $('.product-form__submit').length > 0) {
    $(window).scroll(function() {

      if ($(this).scrollTop() > 106 ) {
        $('.product__media-wrapper').addClass("preview");
        $('.product__info-wrapper').addClass("preview");
      }else{
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

      if ($(this).scrollTop() > $('.product-form__submit').offset().top ) {
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }
      
     });
  }
});  
*/

/*draggable horizontal scroller for gpo-ov-wrapper horizontal  */
setTimeout(function() {
 
  const slider = document.querySelector('.select-background-option .gpo-ov-wrapper.horizontal ');
  let isDown = false;
  let startX;
  let scrollLeft;

  if(slider){
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // The '2' is a speed multiplier
      slider.scrollLeft = scrollLeft - walk;
    });
  }
}, 1500);



$('.hero__reviews').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots:true,
  autoplay:true,
  autoplaySpeed:3500,
  fade: false
});

$window = $(window);
$slick_slider = $('.js-text-slider');
settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  nextArrow: '<span class="arrow-next arrow-btn"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
  prevArrow: '<span class="arrow-prev arrow-btn"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',

};
$slick_slider.slick(settings);

$( window ).on( "load", function() {
  if ($window.width() > 991) {
    if ($slick_slider.hasClass('slick-initialized'))
      $slick_slider.slick('unslick');
    return
  }
});


$window.on('resize', function() {
  if ($window.width() > 991) {
    if ($slick_slider.hasClass('slick-initialized'))
      $slick_slider.slick('unslick');
    return
  }
  if ( ! $slick_slider.hasClass('slick-initialized'))
    return $slick_slider.slick(settings);
});  
                            
$(function() {
    var stickyBtn = $(".sticky-btn-bottom");
    var s = $("#MainContent");
    var pos = s.position();

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll > pos.top) {
            stickyBtn.addClass("active");
        } else {
            stickyBtn.removeClass("active");
        }
    });
});

// Handle sticky button on mobile
$('.prd_mobile_button_sticky .stickymb_btn').click(function(){
  $('body').addClass('active-sticky-bottom');
  $('#product-form-wrapper').addClass('active');
  $('.prd_mobile_button_sticky').hide();
});


$('.quantity-wrapp .quantity-plus').click(function(e){
	var item_id = $(this).attr('item-id');
	var currentVal = parseInt($(this).prev().val());
	if (!isNaN(currentVal) && currentVal < 14) {
  	$(this).prev().val(currentVal + 1);
    var quantity = currentVal + 1;
	} else {
  	$(this).prev().val(14);
     var quantity = 14;
	}
  $('.product-form__input.select-number-of-people-and-pets input[name="Select Number of People and Pets"][value="'+quantity+'"]').next().trigger("click");
  });
$('.quantity-wrapp .quantity-minus').click(function(e){
	var currentVal = parseInt($(this).next().val());
	if (!isNaN(currentVal) && currentVal > 7) {
  	$(this).next().val(currentVal - 1);
    var quantity = currentVal - 1;
	} else {
  	$(this).next().val(7);
     var quantity = 7;
	}
 $('.product-form__input.select-number-of-people-and-pets input[name="Select Number of People and Pets"][value="'+quantity+'"]').next().trigger("click");
});

$('.quantity-wrapp .quantity-number').change(function(e){
  var quantity = $(this).val();
  console.log(quantity);
  $('.product-form__input.select-number-of-people-and-pets input[name="Select Number of People and Pets"][value="'+quantity+'"]').next().trigger("click");
}); 

class CartAddItemFastTurnaround extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var checkboxChecked = $('#fast-turnaround').val();
      if(checkboxChecked == 'Yes'){
       removeItemInMiniCart(40770175434907);
      }else{
        addExtraToMiniCart(40770175434907,1);
      }
    });
  }
}
customElements.define('cart-add-item-fast-turnaround', CartAddItemFastTurnaround);

class CartAddItemScreenRecording extends HTMLElement {
  constructor() {
    super();
    const processScreenRecording = this.querySelectorAll('div.checkbox .process-screen-recording');
    const arrProcessScreenRecording = Array.from(processScreenRecording);
    arrProcessScreenRecording.forEach((elm) => {
      elm.addEventListener('click', (event) => {
        event.preventDefault();
        var checkboxCheckedScreen = $('#screen-recording').val(); 
        if(checkboxCheckedScreen == 'Yes'){
          removeItemInMiniCart(47134693327100);
        }else{
          addExtraToMiniCart(47134693327100,1);
        }
      });
    })
  }
}
customElements.define('cart-add-item-screen-recording', CartAddItemScreenRecording);

class ModalPopup extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-popup', ModalPopup);

class ModalPopupOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-popup-opener', ModalPopupOpener);


/* attach event listener to the product form */
window.addEventListener('upload:added', function(e) {
    /* event detail contains the file reference */
    $('#shopping-bag').addClass('loading');  
    var file = e.detail;
    /* print file on console to see all attributes */
    console.debug('file added', file);

    /* if image thumbnail is enabled
      then the event is executed twice, once for the original and once for the thumbnail
      check the file.meta.variant to decide which version this event is from
     */
    if(file.url && file.meta.variant === 'thumbnail'){
        console.log('file is thumbnail!');
    }

    /* url contains the link to the file */
    console.log('new file: ' + file.url);
    const line_id = $('.upload-lift-wrraper').attr('data-line-id');
    const line = $('#shopping-bag .cart-item-'+line_id).attr('data-line-index');
    console.log(line_id);
    console.log(line);
    
    var properties = {};

   /*
    var current_properties = $('#shopping-bag .cart-product-'+line_id+' .product-option.property.no-upload-image');
    if(current_properties.length > 0){
      current_properties.each(function(index, element) {
        var key = $(element).data('property-key');
        console.log(key);
        var value = $(element).data('property-value');
        console.log(key);
        properties[key] = value;
      });
    }
    */

    
      fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart data with properties:', cart);
        // You can then iterate through cart.items and access item.properties
        cart.items.forEach(item => {
          if(item.id == line_id && item.properties){
            for (const propertyName in item.properties) {
              console.log(`${propertyName}: ${item.properties[propertyName]}`);
              properties[`${propertyName}`] = `${item.properties[propertyName]}`;
            }
            var count_uploaded_images = $('#shopping-bag .cart-item-'+line_id).find('.product-option.property.upload-image').length;
    
              count_uploaded_images = count_uploaded_images + 1;
              var key_upload_file = 'Uploaded_images_'+ count_uploaded_images;
              var value_upload_file = file.url;
              properties[key_upload_file] = value_upload_file;
            
              let formData = {
                'line': line,
                "properties": properties
              };
              
              fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                //return response.json();
                //cart_load();
                $('#shopping-bag').removeClass('loading');  
                const handler_property_uploaded_images = key_upload_file.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                const insertProperty = `
                <div class="product-option property property-`+handler_property_uploaded_images+` upload-image" style="word-break: break-word;" data-property-key="`+key_upload_file+`" data-property-value="`+value_upload_file+`"> `+key_upload_file+`:
                    <span class="property-right cl-prop">
                    <a class="remove-upload-file" onclick="removeUploadFile(`+line_id+`,'`+value_upload_file+`')"><svg width="22" height="22" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><path d="M11.586 13l-2.293 2.293a1 1 0 0 0 1.414 1.414L13 14.414l2.293 2.293a1 1 0 0 0 1.414-1.414L14.414 13l2.293-2.293a1 1 0 0 0-1.414-1.414L13 11.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L11.586 13z" fill="#fff" fill-rule="nonzero"></path></svg></a>
                      <a href="`+value_upload_file+`" class="link">
                        <img src=`+value_upload_file+` style="width:80px;height:80px;vertical-align:middle;object-fit: cover;">
                      </a>
                    </span>
                </div>
                `;
                $('#shopping-bag .cart-item-'+line_id).find('.cart__meta-text').append(insertProperty);
                $('.cl-prop a.link').magnificPopup({
                  type: 'image',
                  callbacks: {
                  open: function() {
                    $("#shopping-bag").removeClass('show-bag');
                  },
                  close: function() {
                    $("#shopping-bag").addClass('show-bag');
                  }
                }
                });
              })
              .catch((error) => {
                console.error('Error:', error);
              })

          }
        });
      });
    
  
});

window.addEventListener('upload:removed', function(e) {
    /* event detail contains the file reference */
    $('#shopping-bag').addClass('loading');  
    let file = e.detail;
    console.log(file);
    console.log('file deleted: ' + file.url);

    const line = $('#shopping-bag .cart-product-'+file.meta.productId).data('line-index');
    console.log(line);
    
    var properties = {};

    var current_properties = $('#shopping-bag .cart-product-'+file.meta.productId+' .product-option.property.no-upload-image');
    if(current_properties.length > 0){
      current_properties.each(function(index, element) {
        var key = $(element).data('property-key');
        console.log(key);
        var value = $(element).data('property-value');
        console.log(key);
        properties[key] = value;
      });
    }

    setTimeout(function() {
      var uploaded_images = $('.cl-upload--wrapper input[name*="properties"]');
      var count_uploaded_images = $('.cl-upload--wrapper input[name*="properties"]').length;
      console.log(count_uploaded_images);

      if(count_uploaded_images > 0){
        uploaded_images.each(function(index, element) {
          var key = $(element).attr('name').replace('properties[','').replace(']','');
          var value = $(element).val();
          properties[key] = value;
        });
      }
    
      let formData = {
        'line': line,
        "properties": properties
      };
      
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        //return response.json();
        //cart_load();
        $('#shopping-bag').removeClass('loading');  
        $('#shopping-bag .cart-product-'+file.meta.productId).find('.product-option.property.upload-image').remove();
        if(count_uploaded_images > 0){
          uploaded_images.each(function(index, element) {
            var key = $(element).attr('name').replace('properties[','').replace(']','');
            var value = $(element).val();
            properties[key] = value;
            const handler_property_uploaded_images = key.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            const insertProperty = `
            <div class="product-option property property-`+handler_property_uploaded_images+` upload-image" style="word-break: break-word;" data-property-key="`+key+`" data-property-value="`+value+`"> `+key+`: 
                <span class="cl-prop">
                  <a href="`+value+`" target="_blank" style="cursor:pointer;border:0;">🔗</a>
                </span>
            </div>
            `;
            $('#shopping-bag .cart-product-'+file.meta.productId).find('.cart__meta-text').append(insertProperty);
          });
        }
        
      })
      .catch((error) => {
        console.error('Error:', error);
      })

    }, 200);

});

function customUploadFiles(line_id){
  //$('#shopping-bag').addClass('loading');  
  window.Cloudlift.upload.App.setup();
  $('.upload-lift-wrraper').attr('data-line-id',line_id);
  setTimeout(function() {
    $('.upload-lift-wrraper .filepond--drop-label label').click();
  }, 200);
}

function removeUploadFile(line_id,image_url){
  $('#shopping-bag').addClass('loading'); 
  console.log(line_id);
  console.log(image_url);
    const line = $('#shopping-bag .cart-item-'+line_id).attr('data-line-index');
    console.log(line);
    
    var properties = {};

      fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart data with properties:', cart);
        // You can then iterate through cart.items and access item.properties
        cart.items.forEach(item => {
          if(item.id == line_id && item.properties){
            var propertiesImages = [];
            for (const propertyName in item.properties) {
              console.log(`${propertyName}: ${item.properties[propertyName]}`);
              if(propertyName.indexOf("Uploaded_images") != -1){
                propertiesImages.push(item.properties[propertyName]);
              }else{
               properties[`${propertyName}`] = `${item.properties[propertyName]}`;
              }
            }
            console.log(propertiesImages);
            propertiesImages = jQuery.grep(propertiesImages, function(value) {
              return value != image_url;
            });
            console.log(propertiesImages);
            console.log(properties);
            $.each(propertiesImages, function(index, value) {
              index+=1;
              var key_upload_file = 'Uploaded_images_'+ index;
              var value_upload_file = value;
              properties[key_upload_file] = value_upload_file;
            });
            
 
              let formData = {
                'line': line,
                "properties": properties
              };
              
              fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                //return response.json();
                cart_load();
                //$('#shopping-bag').removeClass('loading');  
              })
              .catch((error) => {
                console.error('Error:', error);
              })

          }
        });
      });

}

const sleep = ms => new Promise(res => setTimeout(res, ms));
const input = document.querySelector("input");

input.addEventListener('click', () => handleFileUpload());

async function handleFileUpload() {
  input.value = '';
  let closed = false;
  let ua = navigator.userAgent.toLowerCase().toLowerCase();
  let firefoxOrSafari = ua.includes('firefox') || ua.includes('safari');
  let eventType =  firefoxOrSafari ? 'mouseover' : 'focus';
  let listener = window.addEventListener(eventType, () => closed = true);
  while (!closed) {
    await sleep(100);
    !firefoxOrSafari && input.focus();
  }
  window.removeEventListener(eventType, listener);
  await sleep(1000);
  const files = input.files;
  if (!files.length) {
    console.log('No file upload today then?');
  }
  else {
    console.log('Uploading!\n\n' + [...files].map(({ name }) => name).join('\n'));
    // await doUpload(files); // upload the files
    input.value = '';
  }
}

jQuery.fn.shake = function (interval, distance, times) {
  (interval = typeof interval > "u" ? 100 : interval), (distance = typeof distance > "u" ? 10 : distance), (times = typeof times > "u" ? 3 : times);
  var jTarget = $(this);
  jTarget.css("position", "relative");
  for (var iter = 0; iter < times + 1; iter++) jTarget.animate({ left: iter % 2 == 0 ? distance : distance * -1 }, interval);
  return jTarget.animate({ left: 0 }, interval);
};


